import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  result: string | null | undefined
}

export const KycArchiveResultChip: React.FC<ComponentProps> = ({ result }: ComponentProps) => {
  let label: string
  let color: 'success' | 'error' | undefined

  if (result === 'A') {
    label = 'Accepted'
    color = 'success'
  } else if (result === 'R') {
    label = 'Rejected'
    color = 'error'
  } else if (result === 'D') {
    label = 'Denied'
    color = 'error'
  } else if (result === 'C') {
    label = 'Cancelled'
    color = undefined
  } else {
    label = result ?? '-'
    color = undefined
  }

  return (
    <Tooltip title={`Result: ${result ?? '-'}`} TransitionComponent={Zoom} arrow placement='bottom'>
      <Chip label={label} variant='outlined' color={color} />
    </Tooltip>
  )
}
